import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { mergeMap, Observable, ReplaySubject, BehaviorSubject } from 'rxjs';
import { AdminUser } from '../admin/user/user.model';
import { Account } from './account.model';
import { AccountService } from './account.service';
import { AuthTokenService } from './auth-token.service';
import { Login } from './login/login.model';
import { ApplicationConfigService } from '../core/config/application-config.service';

import { IAuthenticatedUserInfo } from './auth.model';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUserSource = new ReplaySubject<AdminUser | null>(1);
  currentUser$ = this.currentUserSource.asObservable();

  private currentUserSourceForSignatory = new BehaviorSubject<IAuthenticatedUserInfo | any>(null);
  currentUserForSignatory$ = this.currentUserSourceForSignatory.asObservable();
  private resourceUrl = '';

  constructor(
    private http: HttpClient,
    private appConfigService: ApplicationConfigService,
    private router: Router,
    private accountService: AccountService,
    private authTokenService: AuthTokenService,
  ) {
    this.currentUserSourceForSignatory.next(JSON.parse(localStorage.getItem('userInfo')!));
    this.resourceUrl = this.appConfigService.getEndpointFor('account-portal');
  }

  login(payload: any): Observable<Account | null> {
    return this.authTokenService.login(payload).pipe(mergeMap(() => this.accountService.identity(true)));
  }

  logout(): void {
    this.authTokenService.logout().subscribe({
      complete: () => {
        this.accountService.authenticate(null);
        localStorage.removeItem('userAssignedMenus');
        this.router.navigate(['/auth/login']);
      },
    });
  }

  // For Signaroty-Hierarchy
  getAuthenticatedUserInfo() {
    return this.http.get(`${this.resourceUrl}/user/details`);
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem('token');
  }

  get getLoggedInuserInfo(): IAuthenticatedUserInfo {
    return this.currentUserSourceForSignatory.value!;
  }

  hasPermission(permission: number[] | null) {
    if (this.getLoggedInuserInfo.role === 1001) {
      return true;
    } else {
      return permission?.includes(this.getLoggedInuserInfo?.userLevel);
    }
  }
}
